import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { isProjectProcessingError, PROJECT_SELECTION_ROUTE } from './project-processing-error.util';

/**
 * Handles project-scoped errors returned by the server.
 *
 * Currently: when a project becomes Processing/Upgrading the server blocks project-scoped
 * requests with 403 + REASON tag ERROR__PROJECT_IS_PROCESSING. We return the user to project
 * selection and treat the error as fully handled here (complete the stream instead of
 * re-throwing) so it does NOT fall through to HttpErrorInterceptor, whose generic 401/403
 * handling would clear the session and log the user out.
 *
 * Registration order matters: this interceptor must be registered AFTER HttpErrorInterceptor
 * so that, on the response path (which unwinds in reverse), its catchError runs first.
 */
@Injectable()
export class ProjectErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (isProjectProcessingError(error)) {
                    this.router.navigate([PROJECT_SELECTION_ROUTE]);
                    return EMPTY;
                }
                return throwError(() => error);
            })
        );
    }
}
